module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Remembering Farley")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "style.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Mom in a restaurant is like a single guy at a party.\nHer eyes are always busy.")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who’s here?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who might need me?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who has a spot she can’t get out?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs a dab more mashed potatoes?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who has a loose shoelace?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who can’t read the menu?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs a button fixed?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs a tissue?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs a shoulder?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs help with the door?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs directions to the rest room?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs a compliment?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs his faith restored?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs a friend?")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("Who needs a husband or a wife?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4ee1c3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mom007.vue
// module id = 72
// module chunks = 0